/**
 * Action handler for opening the Oncology File Upload modal.
 */

import { Dispatch } from "@reduxjs/toolkit";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

/**
 * Dispatches the action to open the ONCOLOGY_FILE_UPLOAD_MODAL.
 *
 * @param dispatch - Redux dispatch function
 */
export const handleOncologyFileUploadClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.ONCOLOGY_FILE_UPLOAD_MODAL,
    }),
  );
};
